import React from "react";
import get from "lodash/get";
import { connect } from "react-redux";
import { withNamespaces } from "react-i18next";
import debounce from "lodash/debounce";
import {
  Alert,
  Icon,
  Layout,
  Breadcrumb,
  Input,
  Select,
  Modal,
} from "antd";

import SettingsConsentForm from "../../components/SettingsConsentForm/SettingsConsentForm";
import classes from "./SettingsConsent.css";

import isAuthenticated from "../../utils/isAuthenticated";
import {
  getConsentSingleRequest,
  getSitesRequest,
  getConsentSettingsRequest,
} from "../../api/requests";
import { logout } from "../../reducers/user/actions";
import {
  getConsentCreatePermission,
  getConsentUpdatePermission,
  getConsentDeletePermission,
  getRandomizationAccessPermission,
  getConsentApprovePermission,
  getConsentUnapprovePermission,

  getConsentSettingExportPermission,
  getConsentSettingImportPermission,
  getConsentSettingCopyPermission
} from "../../reducers/user/selectors";

const { Content } = Layout;

const routes = require("../../routes.json");

class SettingsConsentSingle extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      errorMessage: "",
      responseMessage: "",
      consentEdit: null,
      sites: [],
      consentSettings: null,
    };
  }

  async componentDidMount() {
    this.getConsent();
    this.getConsentSettingsRequest();
    const { data } = await getSitesRequest();
    this.setState({ sites: data });
  }

  getConsentSettingsRequest = async () => {
    try {
      const { data } = await getConsentSettingsRequest();
      this.setState({
        consentSettings: data,
      });
    } catch (e) {
      console.log(e);
    }
  };

  getConsent = debounce(
    async () => {
      this.setState({
        errorMessage: null,
        isLoading: true,
        responseMessage: null,
      });

      try {
        const { data } = await getConsentSingleRequest({ id: get(this.props, "match.params.id") });
        this.setState({
          consentEdit: data,
        });
      } catch (e) {
        if (get(e, "response.status") === 401) {
          this.props.logout();
          return;
        }
        this.setState({
          subject: null,
          errorMessage: get(e, "response.data.error", "Error"),
        });
      }

      this.setState({ isLoading: false });
    },
    200
  );

  onConsentEdit = (consent) => () => {
    this.setState({ consentEdit: consent });
  };

  onConsentEditHide = () => {
    this.setState({ consentEdit: null });
  };

  onConsentEditSubmit = () => {

  };

  render() {
    const {
      isLoading,
      consentEdit,
      consentSettings,
    } = this.state;

    return (
      <div style={{ backgroundColor: "#FAFAFA" }}>
        <Layout className={classes.parentContainer}>
          <Content className={classes.content}>
            <h3 className="headline-default">
              {this.props.i18n.t("NamespaceSettingsConsent:Consent Management")}
            </h3>

            <Breadcrumb>
              <Breadcrumb.Item href="/admin/settings">
                {this.props.i18n.t("Admin Settings")}
              </Breadcrumb.Item>
              <Breadcrumb.Item href="/admin/consent/editor">
                {this.props.i18n.t(
                  "NamespaceSettingsConsent:Consent Management"
                )}
              </Breadcrumb.Item>
              {consentEdit && (
                <Breadcrumb.Item>
                  {this.props.i18n.t("NamespaceSettingsConsent:Edit")}
                </Breadcrumb.Item>
              )}
            </Breadcrumb>
            <br />


            {isLoading && <Icon type="loading" />}

            {consentEdit && consentSettings && (
              <SettingsConsentForm
                {...consentEdit}
                consentSettings={consentSettings}
                onSubmit={this.onConsentEditSubmit}
                onCancel={() => {
                  this.props.history.push(routes.admin.consentEditor);
                }}
              />
            )}
          </Content>
        </Layout>
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  consentCreatePermission: getConsentCreatePermission(state),
  consentUpdatePermission: getConsentUpdatePermission(state),
  consentDeletePermission: getConsentDeletePermission(state),
  randomizationAccessPermission: getRandomizationAccessPermission(state),
  consentApprovePermission: getConsentApprovePermission(state),
  consentUnapprovePermission: getConsentUnapprovePermission(state),
  consentSettingExportPermission: getConsentSettingExportPermission(state),
  consentSettingImportPermission: getConsentSettingImportPermission(state),
  consentSettingCopyPermission: getConsentSettingCopyPermission(state),
});

const mapDispatchToProps = { logout };

export default isAuthenticated(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(withNamespaces()(SettingsConsentSingle))
);



// WEBPACK FOOTER //
// ./src/containers/SettingsConsent/SettingsConsentSingle.js